import { CircularProgress } from "@mui/material";
import { Fragment } from "react";
import {
	Modal,
	ModalFooter,
} from "src/components/Modals/Components/ModalsComponents";

import { PrimaryButton, TextPrimaryButton } from "../../Default/LekUI/Button";

export const Actions = ({ children }) => {
	return <div className="footer mt-16">{children}</div>;
};

function DefaultModal(props) {
	const renderSecondaryButton = () => {
		if (props.renderSecondaryButton) {
			return props.renderSecondaryButton();
		}

		if (!props.secondaryText) {
			return null;
		}

		return (
			<TextPrimaryButton
				onClick={props.onSecondaryClick}
				className={props.secondaryClassName}
				{...(props.secondaryButtonProps || {})}
			>
				{props.secondaryText}
			</TextPrimaryButton>
		);
	};

	const renderPrimaryButton = () => {
		if (!props.primaryText) {
			return null;
		}

		const Component = props.PrimaryComponent || Fragment;

		return (
			<Component>
				<PrimaryButton
					onClick={props.onPrimaryClick}
					color={props.variant || "primary"}
					disabled={props.disabled}
					className={props.primaryClassName}
				>
					{props.primaryText}
				</PrimaryButton>
			</Component>
		);
	};

	const renderContent = () => {
		if (props.isSuccess && props.renderSuccess) {
			return props.renderSuccess();
		}

		return (
			<div className="w-100">
				{props.isLoading && <CircularProgress />}
				{!props.isLoading && props.children}
				{!props.skipActions && (
					<ModalFooter>
						{renderSecondaryButton()}
						{renderPrimaryButton()}
					</ModalFooter>
				)}
			</div>
		);
	};

	return (
		<Modal onClose={props.onClose} fullWidth={props.fullWidth}>
			<div className="flex items-center flex-col p-relative z-index-99">
				{renderContent()}
			</div>
		</Modal>
	);
}

export default DefaultModal;
